// src/stage2/sceneExterior/TreesField.jsx
import React, { useMemo } from 'react';
import { useGLTF } from '@react-three/drei';

const TREE_URL = '/stageAssets/stage2/scene/Stage2Exterior-Tree1.glb';

/* --------------------------  Single Tree  -------------------------- */
function Tree({ position = [0, 0, 0], rotation = [0, 0, 0], scale = 1 }) {
  const { scene } = useGLTF(TREE_URL);

  // Clone so multiple instances can use the same base GLB
  const tree = useMemo(() => (scene ? scene.clone(true) : null), [scene]);
  if (!tree) return null;

  return (
    <primitive
      object={tree}
      position={position}
      rotation={rotation}
      scale={scale}
    />
  );
}

useGLTF.preload(TREE_URL);

/* ----------------------  Field of Many Trees  ---------------------- */
export function TreesField() {
  const trees = [
    { id: 1, pos: [7, 0, -8], scale: 1.4 , rot: [0, Math.PI, 0]},
    { id: 2, pos: [8, 0, -10], scale: 1.2 },
    { id: 3, pos: [41, 1.5, 28], scale: 2.5, rot: [0, Math.PI * 2, 0] },
    { id: 4, pos: [-13.5, 0.2, 0.15], scale: 0.75, rot: [0, Math.PI * 2, 0] },
    { id: 5, pos: [-13, 0.8, 2.45], scale: 1, rot: [0, Math.PI * 1.25, 0] },
    { id: 6, pos: [-10, 0.8, 2.45], scale: 0.65, rot: [0, Math.PI * -0.65, 0] },
    
    //behind gadren brick wall
    { id: 7, pos: [-38, 1.45, 7], scale: 0.65, rot: [0, Math.PI * 0.5, 0] },
    { id: 8, pos: [-39, 1.5, 10], scale: 0.65, rot: [0, Math.PI * 0.85, 0] },
    { id: 9, pos: [-34, 1.5, 9], scale: 0.65, rot: [0, Math.PI * 0.85, 0] },

    { id: 10, pos: [-38, 2, 28], scale: 1, rot: [0, Math.PI * 0.85, 0] },
    { id: 11, pos: [-39, 1.5, 20], scale: 1, rot: [0, Math.PI * 0.56, 0] },
    { id: 12, pos: [-40, 2, 23], scale: 0.75, rot: [0, Math.PI * 0.86, 0] },
    { id: 13, pos: [-35, 1.75, 22], scale: 0.75, rot: [0, Math.PI * 0.56, 0] },




  ];

  return (
    <>
      {trees.map((t) => (
        <Tree key={t.id} position={t.pos} scale={t.scale} rotation={t.rot} />
      ))}
    </>
  );
}
